export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-22.1ff80d3b.jpg";